import React from 'react';

const WorkspaceCheckboxes: React.FC<{
  workspaces: { id: string; name: string }[];
  selected: string[];
  onChange: (ids: string[]) => void;
}> = ({ workspaces, selected, onChange }) => {
  const toggle = (id: string) =>
    onChange(selected.includes(id) ? selected.filter((x) => x !== id) : [...selected, id]);
  return (
    <div className="flex flex-wrap gap-3">
      {workspaces.map((w) => (
        <label key={w.id} className="inline-flex items-center gap-2 text-sm text-gray-700 dark:text-gray-300">
          <input type="checkbox" checked={selected.includes(w.id)} onChange={() => toggle(w.id)} className="rounded border-gray-300 dark:border-gray-600" />
          {w.name}
        </label>
      ))}
      {workspaces.length === 0 && <span className="text-xs text-gray-400">No workspaces available</span>}
    </div>
  );
};

export default WorkspaceCheckboxes;
